module.exports = {
  "my": {
    "my": "我的",
    "myEvaluation": "我的测评",
    "myReport": "我的报告",
    "personalInfo": "个人信息",
    "avatar": "头像",
    "name": "姓名",
    "nameHint": "请输入姓名",
    "phoneNumber": "手机号",
    "telphoneHint": "请输入手机号码",
    "account": "账号",
    "accountHint": "请输入账号",
    "sex": "性别",
    "birthday": "生日",
    "serialNumber": "编号",
    "serialNumberHint": "请输入编号",
    "email": "电子邮箱",
    "emailHint": "请输入电子邮箱",
    "exitLogin": "退出登录",
    "mySettings": "我的设置",
    "moreSettings": "更多设置",
    "changePassword": "修改密码",
    "changePasswordHint": "密码修改成功",
    "oldPassword": "旧密码",
    "oldPasswordHint": "请输入旧密码",
    "newPassword": "新密码",
    "newPasswordHint": "请输入新密码",
    "newPassword2": "确认密码",
    "newPassword2Hint": "请再次输入新密码",
    "newPassword2Hint2": "两次输入的新密码不相同",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/my/en.js